<template>
  <div>
    <b-modal id="reportsModal" size="xl" content-class="menu-bg-blue-transparent-modal dpr-reports-modal" title="Daily Productivity Report"
      centered hide-footer @show="initGraphs()">
      <b-container>
        <b-tabs align="center" pills card>
          <b-row align-h="center" align-v="center" class="pt-3" style="width: 100%" no-gutters>
            <b-col cols="5">
              <b-button :variant="dailyButtonClassCtrl" class="btn btn-md"
                @click="reportsFilterButtonSelected('Daily')">
                Daily
              </b-button>
              <b-button :variant="weeklyButtonClassCtrl" class="btn btn-md"
                @click="reportsFilterButtonSelected('Weekly')">
                Weekly
              </b-button>
              <b-button :variant="monthlyButtonClassCtrl" class="btn btn-md"
                @click="reportsFilterButtonSelected('Monthly')">
                Monthly
              </b-button>
              <b-button :variant="quarterlyButtonClassCtrl" class="btn btn-md"
                @click="reportsFilterButtonSelected('Quarterly')">
                Quarterly
              </b-button>
               <b-button :variant="yearlyButtonClassCtrl" class="btn btn-md"
                @click="reportsFilterButtonSelected('Yearly')">
                Yearly
              </b-button>
            </b-col>
            <b-col cols="2.5" v-if="quarterlyInputCtrl" class="pr-2">
              <b-select class="form-control mx-1" id="quarterSelect" v-model="reportsSelectedQuarter"
                @change="refreshAllGraphs()">
                <b-select-option v-for="quarter in ReportQuarters" :key="quarter.id" :value="quarter.id"
                  :disabled="quarter.disabled">
                  {{ quarter.quarter }}
                </b-select-option>
              </b-select>
            </b-col>
            <b-col cols="1.5" v-if="quarterlyInputCtrl" class="px-2">
              <input type="number" class="form-control sm" onKeyDown="return false" placeholder="year" :min="1999"
                :max="maxQuarterYear" v-model="qYear" @change="clickEventQuarterlyYear()" />
            </b-col>
            <b-col cols="1.5" v-if="yearlyInputCtrl" class="px-2">
              <input type="number" class="form-control sm" onKeyDown="return false" placeholder="year" :min="1999"  :max="maxQuarterYear" v-model="yYear" @change="refreshAllGraphs()" />
            </b-col>
            <b-col cols="2.5" v-if="monthlyInputCtrl" class="px-2">
              <input type="month" class="form-control" id="monthSelect" :max="maxMonth" @change="refreshAllGraphs()"
                v-model="reportsSelectedMonthYear" />
            </b-col>
            <b-col cols="2.5" v-if="weeklyInputCtrl" class="px-2">
              <input type="week" class="form-control" id="weekSelect" :max="maxWeek" @change="refreshAllGraphs()"
                v-model="reportsSelectedWeek" />
            </b-col>
            <b-col cols="2.5" v-if="dailyInputCtrl" class="px-2">
              <input type="date" class="form-control" id="daySelect" :max="currentDate" @change="refreshAllGraphs()"
                v-model="reportsSelectedDay" />
            </b-col>
            <b-col cols="2.5">
              <!-- <label class="row-title">Region :</label> -->
              <b-form-select v-model="dprRegion" v-on:change="refreshAllGraphs()"
                class="form-control form-select row-input">
                <template #first>
                  <b-form-select-option :value="null" disabled>-- Select Region --</b-form-select-option>
                </template>
                <b-form-select-option :key="i" :value="prop.id" v-for="(prop, i) in dprExtents">
                  {{ prop.extent_description }}
                </b-form-select-option>
              </b-form-select>
            </b-col>
          </b-row>
          <!-- Full Down Days Tab -->
          <b-tab title="Full Down Days" @click="refreshAllGraphs()" active>
            <b-row v-show="showFullDownDaysTabs && graphsReady">
              <b-col class="text-center">
                <h5>
                  Number of reports with full down days:
                  {{ numberOfFullDownDays }}
                </h5>
              </b-col>
            </b-row>
            <b-row class="pb-2"></b-row>
            <!-- CHANGE - added graphsReady variabe. Only render charts if they're ready, added spinner -->
            <b-row align-v="center" v-show="showFullDownDaysTabs && graphsReady">
              <b-col>
                <apexchart ref="downDaysPerSystemChart" height="400px" type="line" :options="downDaysPerSystemOptions"
                  :series="downDaysPerSystemSeries">
                </apexchart>
              </b-col>
              <b-col>
                <apexchart ref="fullDownTimeTypeChart" width="100%" height="auto" type="donut"
                  :options="fullDownTimeTypeOptions" :series="fullDownTimeTypeSeries">
                </apexchart>
              </b-col>
            </b-row>
            <b-row class="d-flex justify-content-center align-items-center" v-if="!graphsReady">
              <!-- Loading Spinner -->
              <div class="d-flex justify-content-center align-items-center py-1">
                <span class="spinner-border spinner-border-md highlightLoader" role="status" aria-hidden="true"></span>
                <span class="highlightLoader p-1 spinner-border-md">Loading Data...</span>
              </div>
            </b-row>
            <b-row class="d-flex justify-content-center align-items-center" v-else-if="!showFullDownDaysTabs">
              <!-- Loading Spinner -->
              <div class="d-flex justify-content-center align-items-center py-1">
                <span class="highlightLoader p-1 spinner-border-md">No Data Available</span>
              </div>
            </b-row>
          </b-tab>
          <!-- Partial Down Days Tab -->
          <b-tab title="Partial Down Days" @click="refreshAllGraphs()">
            <b-row v-show="showPartialDownDaysTabs && graphsReady">
              <b-col class="text-center">
                <h5>
                  Number of reports with partial downtime:
                  {{ numberOfPartialDownTimeEntries }}
                </h5>
              </b-col>
            </b-row>
            <b-row class="pb-2" v-show="showPartialDownDaysTabs && graphsReady">
              <b-col class="text-center">
                <h5>
                  Total partial downtime hours:
                  {{ totalPartialHoursDownTime }}
                </h5>
              </b-col>
            </b-row>
            <b-row align-v="center" v-show="showPartialDownDaysTabs && graphsReady">
              <b-col>
                <apexchart ref="partialDownDaysBySystemByTypeChart" height="400px" type="line"
                  :options="partialDownDaysBySystemByTypeOptions" :series="partialDownDaysBySystemByTypeSeries">
                </apexchart>
              </b-col>
              <b-col>
                <apexchart ref="partialDownTimeTypeChart" height="auto" type="donut"
                  :options="partialDownTimeTypeOptions" :series="partialDownTimeTypeSeries">
                </apexchart>
              </b-col>
            </b-row>
            <b-row class="d-flex justify-content-center align-items-center" v-if="!graphsReady">
              <!-- Loading Spinner -->
              <div class="d-flex justify-content-center align-items-center py-1">
                <span class="spinner-border spinner-border-md highlightLoader" role="status" aria-hidden="true"></span>
                <span class="highlightLoader p-1 spinner-border-md">Loading Data...</span>
              </div>
            </b-row>
            <b-row class="d-flex justify-content-center align-items-center" v-else-if="!showPartialDownDaysTabs">
              <!-- Loading Spinner -->
              <div class="d-flex justify-content-center align-items-center py-1">
                <span class="highlightLoader p-1 spinner-border-md">No Data Available</span>
              </div>
            </b-row>
          </b-tab>
          <!-- Collection Tab -->
          <b-tab title="Collection" @click="refreshAllGraphs()">
            <b-row align-v="center" v-show="showCollectionTabs && graphsReady">
              <b-col>
                <apexchart ref="daysCollectedByOperatorChart" height="400px" type="bar" :options="daysCollectedByOperatorOptions"
                  :series="daysCollectedByOperatorSeries">
                </apexchart>
              </b-col>
              <b-col>
                <apexchart ref="operatorDaysPerYearChart" height="auto" type="bar"
                  :options="operatorDaysPerYearOptions" :series="operatorDaysPerYearSeries"></apexchart>
              </b-col>
            </b-row>
            <b-row class="d-flex justify-content-center align-items-center" v-if="!graphsReady">
              <!-- Loading Spinner -->
              <div class="d-flex justify-content-center align-items-center py-1">
                <span class="spinner-border spinner-border-md highlightLoader" role="status" aria-hidden="true"></span>
                <span class="highlightLoader p-1 spinner-border-md">Loading Data...</span>
              </div>
            </b-row>
            <b-row class="d-flex justify-content-center align-items-center" v-else-if="!showCollectionTabs">
              <!-- Loading Spinner -->
              <div class="d-flex justify-content-center align-items-center py-1">
                <span class="highlightLoader p-1 spinner-border-md">No Data Available</span>
              </div>
            </b-row>
          </b-tab>
          <!-- Hours Tab -->
          <b-tab title="Vehicle Hours" @click="refreshAllGraphs()">
            <b-row align-v="center" v-show="showHoursTabs && graphsReady">
              <b-col>
                <apexchart ref="hoursBySystemByTypeChart" width="100%" height="400px" type="line"
                  :options="hoursBySystemByTypeOptions" :series="hoursBySystemByTypeSeries">
                </apexchart>
              </b-col>
              <b-col>
                <apexchart ref="totalHoursTypeChart" height="auto" :options="hoursTypeOptions"
                  :series="hoursTypeSeries">
                </apexchart>
              </b-col>
            </b-row>
            <b-row v-show="showHoursTabs && graphsReady" class="w-100 p-2 dflex justify-content-center align-items-center" no-gutters>
              <b-col class="w-auto pl-4 text-center dpr-hours-note">** Total Hours = Truck Hours + Office Hours **</b-col>
            </b-row>
            <b-row class="d-flex justify-content-center align-items-center" v-if="!graphsReady">
              <!-- Loading Spinner -->
              <div class="d-flex justify-content-center align-items-center py-1">
                <span class="spinner-border spinner-border-md highlightLoader" role="status" aria-hidden="true"></span>
                <span class="highlightLoader p-1 spinner-border-md">Loading Data...</span>
              </div>
            </b-row>
            <b-row class="d-flex justify-content-center align-items-center" v-else-if="!showHoursTabs">
              <!-- Loading Spinner -->
              <div class="d-flex justify-content-center align-items-center py-1">
                <span class="highlightLoader p-1 spinner-border-md">No Data Available</span>
              </div>
            </b-row>
          </b-tab>
          <!-- Hours Tab -->
          <b-tab title="Operator Hours" @click="refreshAllGraphs()">
            <b-row align-v="center" v-show="showOperatorHoursTabs && graphsReady">
              <b-col>
                <apexchart ref="hoursByOperatorsByTypeChart" width="100%" height="400rem" type="line"
                  :options="hoursByOperatorsByTypeOptions" :series="hoursByOperatorsByTypeSeries">
                </apexchart>
              </b-col>
              <b-col>
                <apexchart ref="totalOperatorsHoursTypeChart" height="auto" :options="hoursTypeOperatorsOptions"
                  :series="hoursTypeOperatorsSeries">
                </apexchart>
              </b-col>
            </b-row>
            <b-row v-show="showOperatorHoursTabs && graphsReady" class="w-100 p-2 dflex justify-content-center align-items-center" no-gutters>
              <b-col class="w-auto pl-4 text-center dpr-hours-note">** Total Hours = Truck Hours + Office Hours **</b-col>
            </b-row>
            <b-row class="d-flex justify-content-center align-items-center" v-if="!graphsReady">
              <!-- Loading Spinner -->
              <div class="d-flex justify-content-center align-items-center py-1">
                <span class="spinner-border spinner-border-md highlightLoader" role="status" aria-hidden="true"></span>
                <span class="highlightLoader p-1 spinner-border-md">Loading Data...</span>
              </div>
            </b-row>
            <b-row class="d-flex justify-content-center align-items-center" v-else-if="!showOperatorHoursTabs">
              <!-- Loading Spinner -->
              <div class="d-flex justify-content-center align-items-center py-1">
                <span class="highlightLoader p-1 spinner-border-md">No Data Available</span>
              </div>
            </b-row>
          </b-tab>
        </b-tabs>
      </b-container>
    </b-modal>
  </div>
</template>
<style>
.regionContainer {
  position: relative;
  width: 30%;
  margin-top: 0.3%;
  justify-self: flex-start;
}

.propStyle {
  background: #f3f5f8;
  border: 1px solid rgba(6, 60, 109, 0.2) !important;
  color: #063c6d !important;
}

.row-flex {
  width: 100%;
  display: flex;
  justify-content: left;
}

.row-title {
  float: left;
  width: 30%;
  font-size: 1.1em;
  font-weight: bold;
  margin-top: 0.8em;
}

.row-input {
  float: left;
  justify-content: left;
}

/* ── DPR Reports Modal ─────────────────────────────────── */
.dpr-reports-modal .modal-header {
  background: #063c6d;
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
  padding: 12px 20px;
  border-radius: 7px 7px 0 0;
}
.dpr-reports-modal .modal-title {
  color: #fff;
  font-weight: 600;
  text-shadow: none;
}
.dpr-reports-modal .close {
  color: #fff;
  opacity: 0.8;
  text-shadow: none;
}

/* b-tabs pill nav — dark blue */
.dpr-reports-modal .nav-pills .nav-link {
  color: rgba(6, 60, 109, 0.7);
  background: transparent;
  border: 1px solid rgba(6, 60, 109, 0.2);
  border-radius: 20px;
  font-size: 0.78rem;
  font-weight: 600;
  letter-spacing: 0.03em;
  padding: 4px 14px;
  margin: 0 3px;
}
.dpr-reports-modal .nav-pills .nav-link.active,
.dpr-reports-modal .nav-pills .show > .nav-link {
  background: #063c6d !important;
  border-color: #063c6d !important;
  color: #fff !important;
}
.dpr-reports-modal .nav-pills .nav-link:hover {
  background: rgba(6, 60, 109, 0.08);
  color: #063c6d;
}
.dpr-reports-modal .card {
  background: transparent !important;
  border: none !important;
}
.dpr-reports-modal .tab-content,
.dpr-reports-modal .card-body {
  background: transparent !important;
}

/* Daily/Weekly/Monthly/Quarterly/Yearly filter buttons */
.dpr-reports-modal .btn-primary {
  background: #063c6d !important;
  border-color: #063c6d !important;
  color: #fff !important;
}
.dpr-reports-modal .btn-primary:hover {
  background: #0a5499 !important;
  border-color: #0a5499 !important;
  color: #fff !important;
}
.dpr-reports-modal .btn-light {
  background: transparent !important;
  border: 1px solid rgba(6, 60, 109, 0.25) !important;
  color: rgba(6, 60, 109, 0.7) !important;
}
.dpr-reports-modal .btn-light:hover {
  background: rgba(6, 60, 109, 0.08) !important;
  color: #063c6d !important;
}

/* Form controls */
.dpr-reports-modal .form-control,
.dpr-reports-modal select {
  background: #f3f5f8 !important;
  border: 1px solid rgba(6, 60, 109, 0.2) !important;
  color: #063c6d !important;
}
.dpr-reports-modal .form-control:focus {
  background: #fff !important;
  border-color: #063c6d !important;
  box-shadow: 0 0 0 2px rgba(6, 60, 109, 0.12) !important;
}

/* "Total Hours" annotation */
.dpr-hours-note {
  color: #063c6d;
  font-size: 0.8rem;
  font-weight: 600;
  opacity: 0.75;
}

/* ApexCharts canvas background */
.dpr-reports-modal .apexcharts-canvas {
  background: transparent !important;
}
.dpr-reports-modal .apexcharts-legend-text {
  color: #063c6d !important;
}
.dpr-reports-modal .apexcharts-toolbar svg {
  fill: #063c6d !important;
}
</style>

<script>
import 'vue-date-pick/dist/vueDatePick.css'
import DatePick from 'vue-date-pick'
import axios from 'axios'
export default {
  name: 'MMP_DPR_Reports',
  props: ['extents'],
  components: {
    DatePick
  },

  data() {
    return {
      dprExtents: [],
      selectedExtents: [2, 3, 4, 5, 6],
      dprRegion: '5',
      dprRegionList: [],
      currentDate: new Date().toISOString().slice(0, 10),
      maxWeek: '',
      maxMonth: '',
      availableQuarters: '',
      maxQuarterYear: '',
      showFullDownDaysColumnChart: false,
      showFullDownDaysPieChart: false,
      showPartialDownDaysColumnChart: false,
      showPartialDownDaysPieChart: false,
      showCollectionColumnChart: false,
      showCollectionPieChart: false,
      showHoursColumnChart: false,
      showHoursPieChart: false,
      hoursTypeChart: false,
      showFullDownDaysTabs: false,
      showPartialDownDaysTabs: false,
      showCollectionTabs: false,
      showHoursTabs: false,
      showOperatorHoursTabs: false,
      dailyButtonClassCtrl: 'primary',
      monthlyButtonClassCtrl: 'light',
      weeklyButtonClassCtrl: 'light',
      quarterlyButtonClassCtrl: 'light',
      yearlyButtonClassCtrl: 'light',
      totalPartialHoursDownTime: '',
      reportsSelectedDay: null,
      reportsSelectedWeek: null,
      reportsSelectedMonthYear: null,
      reportsFrequencySelected: 'Daily',
      app: 'dpr',
      numberOfPartialDownTimeEntries: null,
      // Numerical columns do not sort correctly
      dailyInputCtrl: true,
      monthlyInputCtrl: false,
      weeklyInputCtrl: false,
      quarterlyInputCtrl: false,
      yearlyInputCtrl: false,
      numberOfFullDownDays: null,
      ReportQuarters: [
        { id: 1, quarter: 'Jan 1st to March 31st', disabled: false },
        { id: 2, quarter: 'April 1st to June 30th', disabled: false },
        { id: 3, quarter: 'July 1st to Sept 30th', disabled: false },
        { id: 4, quarter: 'Oct 1st to Dec 31st', disabled: false }
      ],
      reportsSelectedQuarter: null,
      qYear: null,
      yYear: null,
      displayFormat: 'YYYY',
      graphsReady: false,
      downDaysPerSystemOptions: {
        chart: {
          id: 'downDaysPerSystem',
          toolbar: {
            show: true,
            tools: {
              download: true // Enables SVG download
            },
          },
          redrawOnParentResize: true,
        },
        dataLabels: {
          enabled: true
        },
        // Property for display smooth curve
        stroke: {
          curve: 'smooth'
        },
        colors: ['#F3B415', '#9999ff', '#99004d','#1aff66', '#663F59', 
                 '#6A6E94', '#4E88B4', '#735240', '#9fc5e8', '#fdfb52', 
                 '#4d0026', '#ff99cc', '#808000', '#bf8040', '#4d3319', 
                 '#6600cc', '#ac3973', '#e6b3cc', '#666699', '#cc0099'],
        xaxis: {
          categories: [],
          labels: {
            style: {
              colors: '#063c6d'
            }
          }
        },
        yaxis: [
          {
            title: {
              text: 'Number of Full Down Days',
              style: {
                color: '#063c6d'
              }
            },
            labels: {
              style: {
                colors: '#063c6d'
              }
            }
          }
        ],
        legend: {
          labels: {
            useSeriesColors: true
          }
        },
        tooltip: {}
      },
      downDaysPerSystemSeries: [
        {
          name: 'series-1',
          data: []
        }
      ],
      fullDownTimeTypeOptions: {
        chart: {
          id: 'fullDownTimeType',
          type: 'donut',
          toolbar: {
            show: true,
            tools: {
              download: true // Enables SVG download
            },
          },
          redrawOnParentResize: true,
        },
        dataLabels: {
          enabled: true
        },
        colors: ['#e07d45', '#da983c', '#b85a23', '#8f9562', '#f9cdd4', '#735240', '#9fc5e8', '#fdfb52', '#cd7f32', '#10b4d3'],
        labels: [],
        legend: {
          labels: {
            useSeriesColors: true
          }
        },
        plotOptions: {}
      },
      fullDownTimeTypeSeries: [],
      //no. of day collected by vehicle
      daysCollectedByOperatorOptions: {
        chart: {
          id: 'daysCollectedByOperator',
          type: 'line',
          toolbar: {
            show: true,
            tools: {
              download: true // Enables SVG download
            },
          },
          redrawOnParentResize: true,
        },
        stroke: {
          curve: 'smooth',
        },
        plotOptions: {
          bar : {
            horizontal: false,
            borderRadiusApplication: 'end',
            distributed: true,
            dataLabels: {
              position: 'top'
            },
          },
        },
        dataLabels: {
          enabled: true,
          offsetY: -20, // moves label higher above the bar (adjust as needed)
        },
        colors:  ['#F3B415', '#9999ff', '#99004d','#1aff66', '#663F59', 
                 '#6A6E94', '#4E88B4', '#735240', '#9fc5e8', '#fdfb52', 
                 '#4d0026', '#ff99cc', '#808000', '#bf8040', '#4d3319', 
                 '#6600cc', '#ac3973', '#e6b3cc', '#666699', '#cc0099'],
        xaxis: {
          categories: [],
          labels: {
            formatter: (val) => val,
            style: {
              colors: '#063c6d',
              fontSize: '12px',
              fontFamily: 'Helvetica, Arial',
              fontWeight: 500,
            }
          }
        },
        yaxis: {
          title: {
            text: 'Number of Collection Days',
            style: {
              color: '#063c6d',
            }
          },
          labels: {
            formatter: (val) => {
              return val.toFixed(2)
            },
            style: {
              colors: '#063c6d',
              fontSize: '12px',
              fontFamily: 'Helvetica, Arial',
              fontWeight: 500,
            }
          },
        },
        tooltip: {
          y: {
            // leave default to preserve original values
            labels: {
              formatter: (val) => val.toFixed(2),
              style: {
                colors: '#063c6d',
                fontSize: '12px',
                fontFamily: 'Helvetica, Arial',
                fontWeight: 500,
              }
            }
          },
          x: {
            labels: {
              formatter: (val) => val.toFixed(2),
              style: {
                colors: '#063c6d',
                fontSize: '12px',
                fontFamily: 'Helvetica, Arial',
                fontWeight: 500,
              }
            }
          }
        },
        fill: {
          opacity: 1
        },
        legend: {
          show: false,
        }
      },
      daysCollectedByOperatorSeries: [
        {
          name: 'series-1',
          data: []
        }
      ],
      partialDownDaysBySystemByTypeOptions: {
        chart: {
          id: 'partialDownDaysBySystemByType',
          toolbar: {
            show: true,
            tools: {
              download: true // Enables SVG download
            },
          },
          redrawOnParentResize: true,
        },
        stroke: {
          curve: 'smooth'
        },
        dataLabels: {
          enabled: true,
          formatter: (val) => {
            return typeof val === 'decimal' && !isNaN(val)
              ? val.toFixed(2)
              : val
          },
        },
        colors:  ['#F3B415', '#9999ff', '#99004d','#1aff66', '#663F59', 
                 '#6A6E94', '#4E88B4', '#735240', '#9fc5e8', '#fdfb52', 
                 '#4d0026', '#ff99cc', '#808000', '#bf8040', '#4d3319', 
                 '#6600cc', '#ac3973', '#e6b3cc', '#666699', '#cc0099'],
        xaxis: {
          categories: [],
          labels: {
            formatter: (val) => {
              return typeof val === 'decimal' && !isNaN(val)
                ? val.toFixed(2)
                : val
            },
            style: {
              colors: '#063c6d'
            }
          }
        },
        yaxis: [
          {
            title: {
              text: 'Number of Hours Down',
              style: {
                color: '#063c6d'
              }
            },
            labels: {
              formatter: (val) => {
                return typeof val === 'decimal' && !isNaN(val)
                  ? val.toFixed(2)
                  : val
              },
              style: {
                colors: '#063c6d'
              }
            }
          }
        ],
        legend: {
          labels: {
            useSeriesColors: true
          }
        },
        tooltip: {
          y: {
            // leave default to preserve original values
            labels: {
              formatter: (val) => val.toFixed(2),
              style: {
                colors: '#063c6d',
                fontSize: '12px',
                fontFamily: 'Helvetica, Arial',
                fontWeight: 500,
              }
            }
          },
          x: {
            labels: {
              formatter: (val) => val.toFixed(2),
              style: {
                colors: '#063c6d',
                fontSize: '12px',
                fontFamily: 'Helvetica, Arial',
                fontWeight: 500,
              }
            }
          }
        },
      },
      partialDownDaysBySystemByTypeSeries: [
        {
          name: 'series-1',
          data: []
        }
      ],
      partialDownTimeTypeOptions: {
        chart: {
          id: 'partialDownTimeType',
          type: 'donut',
          toolbar: {
            show: true,
            tools: {
              download: true // Enables SVG download
            },
          },
          redrawOnParentResize: true,
        },
        dataLabels: {
          enabled: true
        },
        colors: ['#e07d45', '#da983c', '#b85a23', '#8f9562', '#f9cdd4', '#735240', '#9fc5e8', '#fdfb52', '#cd7f32', '#10b4d3'],
        labels: [],
        legend: {
          labels: {
            useSeriesColors: true
          }
        },
        plotOptions: {}
      },
      partialDownTimeTypeSeries: [],
      //no. of day collected by operator
      operatorDaysPerYearOptions: {
        chart: {
          id: 'operatorDaysPerYear',
          toolbar: {
            show: true,
            tools: { download: true },
          },
          redrawOnParentResize: true
        },
        plotOptions: {
          bar: {
            distributed: true,
            styles: {
              colors: ['#063c6d']
            }
          }
        },
        dataLabels: {
          enabled: true,
          position: 'top',
          style: {
            colors: ['#063c6d']
          }
        },
        colors:  ['#F3B415', '#9999ff', '#99004d','#1aff66', '#663F59', 
                 '#6A6E94', '#4E88B4', '#735240', '#9fc5e8', '#fdfb52', 
                 '#4d0026', '#ff99cc', '#808000', '#bf8040', '#4d3319', 
                 '#6600cc', '#ac3973', '#e6b3cc', '#666699', '#cc0099'],
        xaxis: {
          categories: [], // dynamically filled later
          labels: {
            style: {
              colors: '#063c6d'
            }
          }
        },
        yaxis: {
          title: {
            text: 'Number of Collection Days',
            style: {
              color: '#063c6d'
            }
          },
          labels: {
            style: {
              colors: '#063c6d'
            }
          }
        },
        legend: {
          show: false // hide legend for single series bar chart
        }
      },
      operatorDaysPerYearSeries: [
        {
          name: 'series-1',
          data: []
        }
      ],
      hoursBySystemByTypeOptions: {
        chart: {
          id: 'hoursBySystemByType',
          type: 'line',
          height: 500,
          toolbar: {
            show: true,
            tools: {
              download: true // Enables SVG download
            },
          },
          redrawOnParentResize: true,
        },
        stroke: {
          curve: 'smooth',
          show: true
        },
        plotOptions: {
          bar: {
            horizontal: false,
            borderRadiusApplication: 'end'
          },
        },
        dataLabels: {
          enabled: true,
          style: {
            fontSize: '10px',
            fontFamily: 'Helvetica, Arial, sans-serif'
          },
        },
        colors:  ['#F3B415', '#9999ff', '#99004d','#1aff66', '#663F59', 
                 '#6A6E94', '#4E88B4', '#735240', '#9fc5e8', '#fdfb52', 
                 '#4d0026', '#ff99cc', '#808000', '#bf8040', '#4d3319', 
                 '#6600cc', '#ac3973', '#e6b3cc', '#666699', '#cc0099'],
        xaxis: {
          categories: [],
          labels: {
            formatter: (val) => val.toFixed(2),
            style: {
              colors: '#063c6d',
              fontSize: '12px',
              fontFamily: 'Helvetica, Arial',
              fontWeight: 500,
            }
          }
        },
        yaxis: {
          title: {
            text: 'Number of Hours',
            style: {
              color: '#063c6d',
            }
          },
          labels: {
            formatter: (val) => {
              return typeof val === 'decimal' && !isNaN(val)
                ? val.toFixed(2)
                : val
            },
            style: {
              colors: '#063c6d',
              fontSize: '12px',
              fontFamily: 'Helvetica, Arial',
              fontWeight: 500,
            }
          },
        },
        tooltip: {
          y: {
            // leave default to preserve original values
            labels: {
              formatter: (val) => val.toFixed(2),
              style: {
                colors: '#063c6d',
                fontSize: '12px',
                fontFamily: 'Helvetica, Arial',
                fontWeight: 500,
              }
            }
          },
          x: {
            labels: {
              formatter: (val) => val.toFixed(2),
              style: {
                colors: '#063c6d',
                fontSize: '12px',
                fontFamily: 'Helvetica, Arial',
                fontWeight: 500,
              }
            }
          }
        },
        fill: {
          opacity: 1
        },
        legend: {
          show: true,
          labels: {
            useSeriesColors: true,
          }
        }
      },
      hoursBySystemByTypeSeries: [
        {
          name: 'series-1',
          data: []
        }
      ],
      hoursTypeOptions: {
        chart: {
          id: 'hoursType',
          type: 'donut',
          toolbar: {
            show: true,
            tools: {
              download: true // Enables SVG download
            },
          },
          redrawOnParentResize: true,
        },
        dataLabels: {
          enabled: true,
        },
        colors: ['#e07d45', '#da983c', '#b85a23', '#8f9562', '#f9cdd4', '#735240', '#9fc5e8', '#fdfb52', '#cd7f32', '#10b4d3'],
        labels: [],
        legend: {
          labels: {
            useSeriesColors: true
          }
        },
        plotOptions: {}
      },
      hoursTypeSeries: [],

      hoursByOperatorsByTypeOptions: {
        chart: {
          id: 'hoursByOperatorsByType',
          type: 'line',
          width: '100%',
          height: 'auto',
          toolbar: {
            show: true,
            tools: {
              download: true 
            },
          },
          redrawOnParentResize: true,
          padding: { bottom: 120 }
        },
        stroke: {
          curve: 'smooth',
          show: true
        },
        plotOptions: {
          bar: {
            horizontal: false,
            borderRadiusApplication: 'end'
          },
        },
        dataLabels: {
          enabled: true,
          style: {
            fontSize: '10px',
            fontFamily: 'Helvetica, Arial, sans-serif'
          },
        },
        colors:  ['#F3B415', '#9999ff', '#99004d','#1aff66', '#663F59', 
                 '#6A6E94', '#4E88B4', '#735240', '#9fc5e8', '#fdfb52', 
                 '#4d0026', '#ff99cc', '#808000', '#bf8040', '#4d3319', 
                 '#6600cc', '#ac3973', '#e6b3cc', '#666699', '#cc0099'],
        xaxis: {
          categories: [],
          labels: {
            //formatter: (val) => val.toFixed(2),
            style: {
              colors: '#063c6d',
              fontSize: '12px',
              fontFamily: 'Helvetica, Arial',
              fontWeight: 500,
            },
            rotate: -45,
            rotateAlways: true,
            trim: false,
            offsetY: 5,
            maxHeight: 120
          },
          tickPlacement: 'on'
        },
        yaxis: {
          title: {
            text: 'Number of Hours',
            style: {
              color: '#063c6d',
            }
          },
          labels: {
            formatter: (val) => {
              return typeof val === 'decimal' && !isNaN(val)
                ? val.toFixed(2)
                : val
            },
            style: {
              colors: '#063c6d',
              fontSize: '12px',
              fontFamily: 'Helvetica, Arial',
              fontWeight: 500,
            }
          },
        },
        tooltip: {
          y: {
            // leave default to preserve original values
            labels: {
              formatter: (val) => val.toFixed(2),
              style: {
                colors: '#063c6d',
                fontSize: '12px',
                fontFamily: 'Helvetica, Arial',
                fontWeight: 500,
              }
            }
          },
          x: {
            labels: {
              formatter: (val) => val.toFixed(2),
              style: {
                colors: '#063c6d',
                fontSize: '12px',
                fontFamily: 'Helvetica, Arial',
                fontWeight: 500,
              }
            }
          }
        },
        fill: {
          opacity: 1
        },
        legend: {
          labels: {
            useSeriesColors: true,
          },
          show: true,
          position: "bottom",
          horizontalAlign: "center",
          markers: { width: 10, height: 10 },
          itemMargin: { horizontal: 10, vertical: 30 },          
          height: 80,        // force wrap into multiple rows
          width: "100%",     // allow full wrapping
        }
      },
      hoursByOperatorsByTypeSeries: [
        {
          name: 'series-1',
          data: []
        }
      ],
      hoursTypeOperatorsOptions: {
        chart: {
          id: 'hoursTypeOperators',
          type: 'donut',
          toolbar: {
            show: true,
            tools: {
              download: true // Enables SVG download
            },
          },
          redrawOnParentResize: true,
        },
        dataLabels: {
          enabled: true,
        },
        colors: ['#e07d45', '#da983c', '#b85a23', '#8f9562', '#f9cdd4', '#735240', '#9fc5e8', '#fdfb52', '#cd7f32', '#10b4d3'],
        labels: [],
        legend: {
          labels: {
            useSeriesColors: true
          }
        },
        plotOptions: {}
      },
      hoursTypeOperatorsSeries: [],
      
    }
  },
  methods: {
    async initGraphs() {
      // Filter selected extents and Set Extent Array for Region DropDown 
      this.dprExtents = this.extents.filter(x => this.selectedExtents.includes(x.id))
      // Set initial graph display to current month and year, ensure leading 0 on month
      this.graphsReady = false;
      const now = new Date()
      let yesterday = new Date();
      yesterday.setDate(yesterday.getDate() - 1);
      const month = `${now.getMonth() + 1}`.padStart(2, '0')
      // Default month/year for Full Down Days tab
      this.reportsSelectedMonthYear = now.getFullYear() + '-' + month
      // Default week for 'System Collection Days By Week' graph
      let day = yesterday.toISOString().slice(0, 10)
      let week = this.getWeekNumber(now)
      if (week < 10) {
        week = '0' + week
      }
      // Default week for 'Partial Down Days' charts
      this.maxWeek = this.setMaxWeek()
      this.maxMonth = this.setMaxMonth()
      this.availableQuarters = this.setAvailableQuarters()
      this.reportsSelectedDay = day
      this.reportsSelectedWeek = now.getFullYear() + '-W' + week
      this.reportsSelectedQuarter = Math.floor(((month - 1 + 11) / 3) % 4) + 1
      this.qYear = now.getFullYear()
      this.yYear = now.getFullYear()
      await this.refreshAllGraphs()
    },
    async refreshAllGraphs() {
      this.graphsReady = false
      let params = await this.updateParameters()
      this.testParams = params
      await this.updateDownDaysPerSystem(params)
      await this.updateFullDownTimeType(params)
      await this.updatePartialDownTimeType(params)
      await this.updatePartialDownDaysBySystemByType(params)
      await this.updateTotalCollectionDaysPerSystem(params)
      await this.updateOperatorCollectionDays(params)
      await this.updateHoursBySystemByType(params)
      await this.updateHoursByType(params)
      await this.updateHoursByOperatorsByType(params)
      await this.updateHoursTypeOperators(params)

      this.$nextTick(() => {
        this.graphsReady = true
      })
    },
    getWeekNumber(d) {
      // Copy date so don't modify original
      d = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()))
      // Set to nearest Thursday: current date + 4 - current day number
      // Make Sunday's day number 7
      d.setUTCDate(d.getUTCDate() + 4 - (d.getUTCDay() || 7))
      // Get first day of year
      var yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1))
      // Calculate full weeks to nearest Thursday
      var weekNo = Math.ceil(((d - yearStart) / 86400000 + 1) / 7)
      // Return array of year and week number
      return weekNo
    },
    getCalendarDay(d) {
      var dayOfWeek = d.getMonth() + '/' + d.getDate() + '/' + d.getFullYear()
      // Return array of year and week number
      return dayOfWeek
    },
    reportsFilterButtonSelected(selected) {
      // Make selected button primary
      if (selected === 'Daily') {
        this.dailyButtonClassCtrl = 'primary'
        this.weeklyButtonClassCtrl = 'light'
        this.monthlyButtonClassCtrl = 'light'
        this.quarterlyButtonClassCtrl = 'light'
        this.yearlyButtonClassCtrl = 'light'
        this.dailyInputCtrl = true
        this.weeklyInputCtrl = false
        this.monthlyInputCtrl = false
        this.quarterlyInputCtrl = false
        this.yearlyInputCtrl = false
        this.reportsFrequencySelected = 'Daily'
      }
      if (selected === 'Weekly') {
        this.weeklyButtonClassCtrl = 'primary'
        this.dailyButtonClassCtrl = 'light'
        this.monthlyButtonClassCtrl = 'light'
        this.quarterlyButtonClassCtrl = 'light'
        this.yearlyButtonClassCtrl = 'light'
        this.dailyInputCtrl = false
        this.weeklyInputCtrl = true
        this.monthlyInputCtrl = false
        this.quarterlyInputCtrl = false
        this.yearlyInputCtrl = false
        this.reportsFrequencySelected = 'Weekly'
      }
      if (selected === 'Monthly') {
        this.monthlyButtonClassCtrl = 'primary'
        this.dailyButtonClassCtrl = 'light'
        this.weeklyButtonClassCtrl = 'light'
        this.quarterlyButtonClassCtrl = 'light'
        this.yearlyButtonClassCtrl = 'light'
        this.dailyInputCtrl = false
        this.weeklyInputCtrl = false
        this.monthlyInputCtrl = true
        this.quarterlyInputCtrl = false
        this.yearlyInputCtrl = false
        this.reportsFrequencySelected = 'Monthly'
      }
      if (selected === 'Quarterly') {
        this.setAvailableQuarters()
        this.quarterlyButtonClassCtrl = 'primary'
        this.dailyButtonClassCtrl = 'light'
        this.weeklyButtonClassCtrl = 'light'
        this.monthlyButtonClassCtrl = 'light'
        this.yearlyButtonClassCtrl = 'light'
        this.dailyInputCtrl = false
        this.weeklyInputCtrl = false
        this.monthlyInputCtrl = false
        this.quarterlyInputCtrl = true
        this.yearlyInputCtrl = false
        this.reportsFrequencySelected = 'Quarterly'
      }
      if (selected === 'Yearly') {
        this.setAvailableQuarters()
        this.yearlyButtonClassCtrl = 'primary'
        this.quarterlyButtonClassCtrl = 'light'
        this.dailyButtonClassCtrl = 'light'
        this.weeklyButtonClassCtrl = 'light'
        this.monthlyButtonClassCtrl = 'light'        
        this.dailyInputCtrl = false
        this.weeklyInputCtrl = false
        this.monthlyInputCtrl = false
        this.quarterlyInputCtrl = false
        this.yearlyInputCtrl = true
        this.reportsFrequencySelected = 'Yearly'
      }
      // Update graphs to reflect input change
      this.refreshAllGraphs()
    },
    updateParameters() {
      // Removed duplicate parameters from each function and combined
      let requestWeek,
        requestDay,
        requestWeekNumber,
        requestMonthYear,
        requestYear,
        requestMonth,
        requestQuarter
      if (this.reportsFrequencySelected === 'Daily') {
        requestDay = this.reportsSelectedDay
        requestYear = this.reportsSelectedDay.split('-')[0]
        this.testData = this.reportsSelectedDay
      }
      if (this.reportsFrequencySelected === 'Weekly') {
        requestWeek = this.reportsSelectedWeek.split('-')
        requestYear = requestWeek[0]
        requestWeekNumber = requestWeek[1].substring(1)
      }
      if (this.reportsFrequencySelected === 'Monthly') {
        requestMonthYear = this.reportsSelectedMonthYear.split('-')
        requestYear = requestMonthYear[0]
        requestMonth = requestMonthYear[1]
      }
      if (this.reportsFrequencySelected === 'Quarterly') {
        requestQuarter = this.reportsSelectedQuarter
        requestYear = this.qYear
      }
       if (this.reportsFrequencySelected === 'Yearly') {
        requestYear = this.yYear
      }
      const params = {}
      params.region = this.dprRegion
      if (requestDay) {
        params.day = requestDay
      }
      if (requestMonth) {
        params.month = requestMonth
      }
      if (requestYear) {
        params.year = requestYear
      }
      if (requestWeekNumber) {
        params.week = requestWeekNumber
      }
      if (requestQuarter) {
        if (requestQuarter == 1) {
          params.quarter = 1
        } else if (requestQuarter == 2) {
          params.quarter = 4
        } else if (requestQuarter == 3) {
          params.quarter = 7
        } else if (requestQuarter == 4) {
          params.quarter = 10
        }
      }
      return params
    },
    async updateApexCharts(chartId, options) {
      await ApexCharts.exec(chartId, 'updateOptions', options)
    },
    async updateDownDaysPerSystem(params) {
      if (sessionStorage.token) {
        await axios
          .get(process.env.API_LOCATION + '/api/dpr/reports/downDaysPerSystem', {
            headers: {
              'x-auth-token': sessionStorage.token
            },
            params: params
          })
          .then(response => {

            if (response.data.rowCount > 0) {
              this.showFullDownDaysTabs = true
              const content = response.data.rows

              // Sort response data into appropriate axis for graphing
              let xaxis = []
              let distinctReasonDt = []

              //filter all distinct vehicles for x Axis 
              xaxis = content.map(item => item.vehicle_name)
                .filter((value, index, self) => self.indexOf(value) === index)

              //filter all distinct down days reasons
              distinctReasonDt = content.map(item => item.reason_dt)
                .filter((value, index, self) => self.indexOf(value) === index)
              
              let resDtDaysSeries = []
              const sumTotalDownDaysPerVehicle = []

              // variable - Object for vehiclewise down days total
              let toatalBuilder = {
                "name": "Total",
                "type": "line",
                "data": [],
                "color": "#6af2f0"
              }

              //iterate over all distinct reasons
              for (const resdet of distinctReasonDt) {

                // variable - Object for building one reason dt
                let resDetDownDaysBuilder = {
                  "name": resdet,
                  "type": "column",
                  "data": []
                }

                //iterate over all distinct vehicles for one reason dt
                for (const veh of xaxis) {
                  let totaldowndays = 0

                  // filter data when reson dt and vehicle name matches
                  let vehResData = content.filter(i => i.vehicle_name === veh &&
                    i.reason_dt === resdet
                  )

                  //If data is avalaibale for above condition then get total down days property value from dataset or default it to 0
                  totaldowndays = (vehResData != null && vehResData.length > 0) ?
                    vehResData[0].totaldowndays : 0

                  resDetDownDaysBuilder.data.push(parseFloat(totaldowndays).toFixed(2))
                }
                resDtDaysSeries.push(resDetDownDaysBuilder)
              }

              //Calculate Vehicle wise all reason dt Total
              resDtDaysSeries.forEach(row => {
                row.data.forEach((value, index) => {
                  sumTotalDownDaysPerVehicle[index] = (parseInt(sumTotalDownDaysPerVehicle[index]) || 0) +
                    parseInt(value)
                })
              })

              // Asign sum of each Vehicle wise total data to object  
              toatalBuilder.data = sumTotalDownDaysPerVehicle

              //Add Vehicle wise all reason dt Total to Final series
              resDtDaysSeries.push(toatalBuilder)

              this.$nextTick(() => {
                this.updateApexCharts(this.downDaysPerSystemOptions.chart.id, {
                  series: resDtDaysSeries,
                  xaxis: {
                    categories: xaxis
                  }
                })
              })

              this.$refs.downDaysPerSystemChart.updateOptions({
                chart: {
                  toolbar: {
                    export: {
                      csv: {
                        filename: this.getDownLoadFileName('FulldownDaysPerSystem'),
                      },
                      svg: {
                        filename: this.getDownLoadFileName('FulldownDaysPerSystem'),
                      },
                      png: {
                        filename: this.getDownLoadFileName('FulldownDaysPerSystem'),
                      },
                    },
                  },
                },
              })

            }
            else {
              this.showFullDownDaysTabs = false
            }
          })
          .catch(function (error) {
            console.log(error)
          })
      } else {
        console.log('No User Token')
      }
    },
    async updatePartialDownDaysBySystemByType(params) {
      if (sessionStorage.token) {
        await axios
          .get(
            process.env.API_LOCATION +
            '/api/dpr/reports/partialDownDaysBySystemByType',
            {
              headers: {
                'x-auth-token': sessionStorage.token
              },
              params: params
            }
          )
          .then(response => {
            // Set number of reports with partial downtime display

            if (response.data.rows.length > 0) {
              this.showPartialDownDaysTabs = true
              const content = response.data.rows

              this.numberOfPartialDownTimeEntries = response.data.rows.reduce((sum, row) => sum + parseFloat(row.report_count), 0)
              // Sort response data into appropriate axis for graphing
              let xaxis = []
              let counter = 0

              let distinctReasonDtPart = []

              //filter all distinct vehicles for x Axis 
              xaxis = content.map(item => item.vehicle_name)
                .filter((value, index, self) => self.indexOf(value) === index)

              //filter all distinct down days reasons
              distinctReasonDtPart = content.map(item => item.reason_dt_part)
                .filter((value, index, self) => self.indexOf(value) === index)

              let resPartDtHrsSeries = []
              const sumTotalPartDownHrsPerVeh = []

              // variable - Object for vehiclewise down days total
              let partToatalBuilder = {
                "name": "Total",
                "type": "line",
                "data": [],
                "color": "#6af2f0"
              }

              //iterate over all distinct reasons
              for (const resdet of distinctReasonDtPart) {

                // variable - Object for building one reason dt
                let partResDetDownDaysBuilder = {
                  "name": resdet,
                  "type": "column",
                  "data": []
                }

                //iterate over all distinct vehicles for one reason dt
                for (const veh of xaxis) {
                  let partHoursDt = 0

                  // filter data when reson dt and vehicle name matches
                  let vehPartResData = content.filter(i => i.vehicle_name === veh &&
                    i.reason_dt_part === resdet
                  )

                  //If data is avalaibale for above condition then get total down days property value from dataset or default it to 0
                  partHoursDt = (vehPartResData != null && vehPartResData.length > 0) ?
                    vehPartResData[0].hours_dt_partial : 0

                  partResDetDownDaysBuilder.data.push(parseFloat(partHoursDt).toFixed(2))

                }
                resPartDtHrsSeries.push(partResDetDownDaysBuilder)
              }

              //Calculate Vehicle wise all reason dt Total
              resPartDtHrsSeries.forEach(row => {
                row.data.forEach((value, index) => {
                  let sum =
                    parseFloat(parseFloat(parseFloat(sumTotalPartDownHrsPerVeh[index] || 0).toFixed(2))
                      +
                      parseFloat(parseFloat(value).toFixed(2))).toFixed(2)

                  sumTotalPartDownHrsPerVeh[index] = parseFloat(sum)
                })
              })

              // Asign sum of each Vehicle wise total data to object  
              partToatalBuilder.data = sumTotalPartDownHrsPerVeh

              //Add Vehicle wise all reason dt Total to Final series
              resPartDtHrsSeries.push(partToatalBuilder)

              // Assign sorted data to graph
              this.$nextTick(() => {
                this.updateApexCharts(
                  this.partialDownDaysBySystemByTypeOptions.chart.id,
                  {
                    series: resPartDtHrsSeries,
                    xaxis: {
                      categories: xaxis,
                      labels: {
                        formatter: (val) => {
                          return typeof val === 'decimal' && !isNaN(val)
                            ? val.toFixed(2)
                            : val
                        },
                      }
                    }
                  }
                )
              })

              this.$refs.partialDownDaysBySystemByTypeChart.updateOptions({
                chart: {
                  toolbar: {
                    export: {
                      csv: {
                        filename: this.getDownLoadFileName('PartialDownDaysBySystem'),
                      },
                      svg: {
                        filename: this.getDownLoadFileName('PartialDownDaysBySystem'),
                      },
                      png: {
                        filename: this.getDownLoadFileName('PartialDownDaysBySystem'),
                      },
                    },
                  },
                },
              })
            }
            else {
              this.showPartialDownDaysTabs = false
            }
          })
          .catch(function (error) {
            console.log(error)
          })
      } else {
        console.log('No User Token')
      }
    },
    async updatePartialDownTimeType(params) {
      if (sessionStorage.token) {
        await axios
          .get(
            process.env.API_LOCATION + '/api/dpr/reports/partialDownTimeType',
            {
              headers: {
                'x-auth-token': sessionStorage.token
              },
              params: params
            }
          )
          .then(response => {
            // Sort response data into appropriate axis for graphing
            if (response.data.rows.length > 0) {
              this.showPartialDownDaysTabs = true
              let downtimeType = []
              let downtimeTypeSum = []
              let sum = 0

              response.data.rows.forEach(element => {
                downtimeType.push(element.reason_dt_part)
                downtimeTypeSum.push(element.sum)
                sum += parseFloat(element.sum)
              })
              // Assign sorted data to graph
              this.$nextTick(() => {
                this.updateApexCharts(
                  this.partialDownTimeTypeOptions.chart.id,
                  {
                    series: downtimeTypeSum,
                    labels: downtimeType
                  }
                )
              })

              this.$refs.partialDownTimeTypeChart.updateOptions({
                chart: {
                  toolbar: {
                    export: {
                      csv: {
                        filename: this.getDownLoadFileName('PartialDownTime'),
                      },
                      svg: {
                        filename: this.getDownLoadFileName('PartialDownTime'),
                      },
                      png: {
                        filename: this.getDownLoadFileName('PartialDownTime'),
                      },
                    },
                  },
                },
              })

              this.totalPartialHoursDownTime = sum
            }
            else {
              this.showPartialDownDaysTabs = false
            }
          })
          .catch(function (error) {
            console.log(error)
          })
      } else {
        console.log('No User Token')
      }
    },
    async updateFullDownTimeType(params) {
      if (sessionStorage.token) {
        await axios
          .get(process.env.API_LOCATION + '/api/dpr/reports/fullDownTimeType', {
            headers: {
              'x-auth-token': sessionStorage.token
            },
            params: params
          })
          .then(response => {
            // Sort response data into appropriate axis for graphing
            if (response.data.rowCount > 0) {

              this.showFullDownDaysTabs = true
              let downtimeType = []
              let downtimeTypeSum = []
              let sum = 0 //added new variable for displaying sum
              response.data.rows.forEach(element => {
                downtimeType.push(element.reason_dt)
                downtimeTypeSum.push(parseInt(element.total_days_down))
                sum += parseFloat(element.total_days_down) // Sum of the total_days_down
              })
              // Assign sorted data to graph
              this.$nextTick(() => {
                this.updateApexCharts(
                  this.fullDownTimeTypeOptions.chart.id,
                  {
                    series: downtimeTypeSum,
                    labels: downtimeType
                  }
                )
              })

              this.$refs.fullDownTimeTypeChart.updateOptions({
                chart: {
                  toolbar: {
                    export: {
                      csv: {
                        filename: this.getDownLoadFileName('FullDownTime'),
                      },
                      svg: {
                        filename: this.getDownLoadFileName('FullDownTime'),
                      },
                      png: {
                        filename: this.getDownLoadFileName('FullDownTime'),
                      },
                    },
                  },
                },
              })

              this.numberOfFullDownDays = sum // Displayed the sum of total_days_down
            }
            else {
              this.showFullDownDaysTabs = false
            }
          })
          .catch(function (error) {
            console.log(error)
          })
      } else {
        console.log('No User Token')
      }
    },
    //no. of day collected by vehicle
    async updateTotalCollectionDaysPerSystem(params) {
      if (sessionStorage.token) {
        await axios
          .get(
            process.env.API_LOCATION +
            '/api/dpr/reports/totalCollectionDaysPerSystem',
            {
              headers: {
                'x-auth-token': sessionStorage.token
              },
              params: params
            }
          )
          .then(response => {
            // Set number of reports with partial downtime display
            const data = response.data.rows
            if (data.length > 0) {
              // Distinct vehicle names for x-axis
              const xaxis = [...new Set(data.map(d => d.vehicle_name))]
              let num_days_collected = []
              response.data.rows.forEach(element => {
                num_days_collected.push(element.days_collected)
              })

              const maxValue = Math.max(...num_days_collected);

              const series = [{
                name: 'daysCollected',
                data: num_days_collected,
              }]
              // Assign sorted data to graph
              this.$nextTick(() => {
                this.updateApexCharts(
                  this.daysCollectedByOperatorOptions.chart.id,
                  {
                    series: series,
                    xaxis: {
                      categories: xaxis
                    },
                    yaxis: {
                      max: maxValue < 7 ? maxValue + 0.5 : undefined,
                      title: {
                        text: 'Number of Collection Days',
                        style: {
                          color: '#063c6d',
                        }
                      },
                      labels: {
                        formatter: (val) => val.toFixed(2),
                        style: {
                          colors: '#063c6d',
                          fontSize: '12px',
                          fontFamily: 'Helvetica, Arial',
                          fontWeight: 500,
                        }
                      },
                    }
                  }
                )
              })
              this.$refs.daysCollectedByOperatorChart.updateOptions({
                chart: {
                  toolbar: {
                    export: {
                      csv: {
                        filename: this.getDownLoadFileName('TotalCollectionDays'),
                      },
                      svg: {
                        filename: this.getDownLoadFileName('TotalCollectionDays'),
                      },
                      png: {
                        filename: this.getDownLoadFileName('TotalCollectionDays'),
                      },
                    },
                  },
                },
              })
            } else {
              this.showPartialDownDaysTabs = false
            }
          })
          .catch(function (error) {
            console.log(error)
          })
      } else {
        console.log('No User Token')
      }
    },
    //no. of day collected by operator
    async updateOperatorCollectionDays(params) {
      if (sessionStorage.token) {
        await axios
          .get(
            process.env.API_LOCATION + '/api/dpr/reports/operatorCollectionDays',
            {
              headers: {
                'x-auth-token': sessionStorage.token
              },
              params: params
            }
          )
          .then(response => {
            // Sort response data into appropriate axis for graphing

            if (response.data.rows.length > 0) {
              this.showCollectionTabs = true
              let operator = []
              let num_days_collected = []
              response.data.rows.forEach(element => {
                operator.push(element.name)
                num_days_collected.push(element.num_days_collected)
              })

              const maxValue = Math.max(...num_days_collected);

              // Assign sorted data to graph
              this.$nextTick(() => {
                this.updateApexCharts(
                  this.operatorDaysPerYearOptions.chart.id,
                  {
                    chart: {
                      id: 'operatorDaysPerYear',
                      toolbar: {
                        show: true, // Enables toolbar for download
                        tools: {
                          download: true // Enables SVG download
                        },
                      },
                      redrawOnParentResize: true
                    },
                    plotOptions: {
                      bar: {
                        distributed: true,
                        dataLabels: {
                          position: 'top' // This puts the label *above* the bar
                        },
                        styles: {
                          colors: ['#063c6d']
                        }
                      }
                    },
                    dataLabels: {
                      enabled: true,
                      position: 'top',
                      offsetY: -20, // moves label higher above the bar (adjust as needed)

                    },
                    series: [
                      {
                        data: num_days_collected
                      }
                    ],
                    xaxis: {
                      categories: operator,
                      labels: {
                        style: {
                          colors: '#063c6d'
                        }
                      }
                    },
                    yaxis: {
                      max: maxValue < 7 ? maxValue + 0.5 : undefined,
                      title: {
                        text: 'Number of Collection Days',
                        style: {
                          color: '#063c6d'
                        }
                      },
                      labels: {
                        style: {
                          colors: '#063c6d'
                        }
                      }
                    },
                    legend: {
                      labels: {
                        useSeriesColors: true
                      }
                    }
                  }
                )
              })

              this.$refs.operatorDaysPerYearChart.updateOptions({
                chart: {
                  toolbar: {
                    export: {
                      csv: {
                        filename: this.getDownLoadFileName('OperatorDaysPerYear'),
                      },
                      svg: {
                        filename: this.getDownLoadFileName('OperatorDaysPerYear'),
                      },
                      png: {
                        filename: this.getDownLoadFileName('OperatorDaysPerYear'),
                      },
                    },
                  },
                },
              })
            }
            else {
              this.showCollectionTabs = false
            }
          })
          .catch(function (error) {
            console.log(error)
          })
      } else {
        console.log('No User Token')
      }
    },
    closeReports() {
      this.$bvModal.hide('reportsModal')
    },
    setMaxWeek() {
      const today = new Date();
      const year = today.getFullYear();
      const week = this.getWeekNumber(today);
      return `${year}-W${week}`;
    },
    getWeekNumber(date) {
      const oneJan = new Date(date.getFullYear(), 0, 1);
      const numberOfDays = Math.floor((date - oneJan) / (24 * 60 * 60 * 1000));
      return Math.ceil((numberOfDays + oneJan.getDay() + 1) / 7);
    },
    setMaxMonth() {
      const today = new Date();
      const year = today.getFullYear();
      const month = String(today.getMonth() + 1).padStart(2, "0"); // Format as MM
      return `${year}-${month}`; // Format YYYY-MM
    },
    setAvailableQuarters() {
      const today = new Date()
      const year = today.getFullYear()
      const currentQuarter = Math.ceil((today.getMonth() + 1) / 3)
      this.maxQuarterYear = year
      this.ReportQuarters.forEach(element => {
        if (element.id > currentQuarter && this.qYear == year) {
          element.disabled = true
        } else {
          element.disabled = false
        }
      })
    },
    async updateHoursBySystemByType(params) {
      if (sessionStorage.token) {
        await axios
          .get(
            process.env.API_LOCATION +
            '/api/dpr/reports/updateHoursBySystemByType',
            {
              headers: {
                'x-auth-token': sessionStorage.token
              },
              params: params
            }
          )
          .then(response => {
            // Set number of reports with partial downtime display
            if (response.data.rows.length > 0) {
              this.showHoursTabs = true
              // Sort response data into appropriate axis for graphing
              let xaxis = []
              let counter = 0
              // Temp array to build complete series
              let tempSeries = []
              // Temp arrays to build the series (graph y axis data)
              let collection_HoursArr = []
              let office_HoursArr = []
              let truck_HoursArr = []
              // Build x axis with distinct devices found in response data
              response.data.rows.forEach(element => {
                if (!xaxis.includes(element.vehicle_name)) {
                  xaxis.push(element.vehicle_name)
                }
              })

              // Loop through x axis devices and build series for each item
              xaxis.forEach(element => {
                // Build series for each device
                response.data.rows.forEach(subElement => {
                  if (subElement.vehicle_name == element) {
                    // Assign the total down days for each type to temp arrays
                    collection_HoursArr.push(subElement.collection_hours ? subElement.collection_hours : null)
                    office_HoursArr.push(subElement.office_hours ? subElement.office_hours : null)
                    truck_HoursArr.push(subElement.truck_hours ? subElement.truck_hours : null)
                  }
                })
              })

              let tempSeriesBuilder = {
                name: 'Collection Hours',
                type: 'column',
                data: collection_HoursArr
              }
              tempSeries.push(tempSeriesBuilder)

              tempSeriesBuilder = {
                name: 'Office Hours',
                type: 'column',
                data: office_HoursArr
              }
              tempSeries.push(tempSeriesBuilder)

              tempSeriesBuilder = {
                name: 'Truck Hours',
                type: 'column',
                data: truck_HoursArr
              }
              tempSeries.push(tempSeriesBuilder)

              let totalBuildArr = []
              for (let i = 0; i < xaxis.length; i++) {
                let totalOfficeHr = (office_HoursArr[i] != null && office_HoursArr[i] != NaN) ? parseFloat(office_HoursArr[i]) : 0
                let totalTruckHr = (truck_HoursArr[i] != null && truck_HoursArr[i] != NaN) ? parseFloat(truck_HoursArr[i]) : 0
                let deviceTotal = parseFloat(totalOfficeHr + totalTruckHr).toFixed(2)

                totalBuildArr.push(parseFloat(deviceTotal))
              }

              tempSeriesBuilder = {
                name: 'Total',
                type: 'line',
                data: totalBuildArr,
                color: '#6af2f0'
              }
              tempSeries.push(tempSeriesBuilder)

              // Assign sorted data to graph
              this.$nextTick(() => {
                this.updateApexCharts(
                  this.hoursBySystemByTypeOptions.chart.id,
                  {
                    series: tempSeries,
                    xaxis: {
                      categories: xaxis
                    }
                  }
                )
              })

              this.$refs.hoursBySystemByTypeChart.updateOptions({
                chart: {
                  toolbar: {
                    export: {
                      csv: {
                        filename: this.getDownLoadFileName('HoursBySystem'),
                      },
                      svg: {
                        filename: this.getDownLoadFileName('HoursBySystem'),
                      },
                      png: {
                        filename: this.getDownLoadFileName('HoursBySystem'),
                      },
                    },
                  },
                },
              })
            }
            else {
              this.showHoursTabs = false
            }
          })
          .catch(function (error) {
            console.log(error)
          })
      } else {
        console.log('No User Token')
      }
    },
    async updateHoursByType(params) {
      if (sessionStorage.token) {
        await axios
          .get(process.env.API_LOCATION + '/api/dpr/reports/updateHoursByType', {
            headers: {
              'x-auth-token': sessionStorage.token
            },
            params: params
          })
          .then(response => {
            if (response.data.rows.length <= 0) {
              this.showHoursTabs = false
              return;
            }

            let filResult = response.data.rows.filter(x => x.total_hours != null)

            // Sort response data into appropriate axis for graphing
            if (filResult.length > 0) {

              this.showHoursTabs = true
              let hoursType = []
              let hoursTypeSum = []
              let sum = 0 //added new variable for displaying sum
              response.data.rows.forEach(element => {
                if (element.total_hours) {
                  hoursType.push(element.hours_label)
                  hoursTypeSum.push(parseInt(element.total_hours))
                }

                sum += parseFloat(parseInt(element.total_hours)) // Sum of the total_days_down
              })
              // Assign sorted data to graph
              this.$nextTick(() => {
                this.updateApexCharts(
                  this.hoursTypeOptions.chart.id,
                  {
                    series: hoursTypeSum,
                    labels: hoursType
                  }
                )
              })

              this.$refs.totalHoursTypeChart.updateOptions({
                chart: {
                  toolbar: {
                    export: {
                      csv: {
                        filename: this.getDownLoadFileName('TotalHoursType'),
                      },
                      svg: {
                        filename: this.getDownLoadFileName('TotalHoursType'),
                      },
                      png: {
                        filename: this.getDownLoadFileName('TotalHoursType'),
                      },
                    },
                  },
                },
              })
            }
            else {
              this.showHoursTabs = false
            }
          })
          .catch(function (error) {
            console.log(error)
          })
      } else {
        console.log('No User Token')
      }
    },

/* ------------------------------ Hours By Operators -----------------------------------*/

    async updateHoursByOperatorsByType(params) {
      if (sessionStorage.token) {
        await axios
          .get(
            process.env.API_LOCATION +
            '/api/dpr/reports/updateHoursByOperatorsByType',
            {
              headers: {
                'x-auth-token': sessionStorage.token
              },
              params: params
            }
          )
          .then(response => {
            // Set number of reports with partial downtime display
            if (response.data.rows.length > 0) {            
              this.showOperatorHoursTabs = true
              // Sort response data into appropriate axis for graphing
              let xaxis = []             
              // Temp array to build complete series
              let tempSeries = []
              // Temp arrays to build the series (graph y axis data)
              let collection_HoursArr = []
              let office_HoursArr = []
              let truck_HoursArr = []
              // Build x axis with distinct devices found in response data
              response.data.rows.forEach(element => {
                // Iterating over Operating_id instead of Operator_name because Some Operators have different operator_ids but same operator name 
                if (!xaxis.includes(element.operator_id)) {
                  xaxis.push(element.operator_id)
                }
              })              

              // Loop through x axis devices and build series for each item
              xaxis.forEach(element => {
                // Build series for each device
                response.data.rows.forEach(subElement => {
                  if (subElement.operator_id == element) {

                    //Replacing Operator_id with Operator name to show data labels by operator names
                    const index = xaxis.indexOf(element);
                    if (index !== -1) { 
                       xaxis[index] = subElement.operator_name;
                      }
                    
                    // Assign the total down days for each type to temp arrays
                    collection_HoursArr.push(subElement.collection_hours ? subElement.collection_hours : null)
                    office_HoursArr.push(subElement.office_hours ? subElement.office_hours : null)
                    truck_HoursArr.push(subElement.truck_hours ? subElement.truck_hours : null)
                  }
                })
              })
              
              let tempSeriesBuilder = {
                name: 'Collection Hours',
                type: 'column',
                data: collection_HoursArr
              }
              tempSeries.push(tempSeriesBuilder)

              tempSeriesBuilder = {
                name: 'Office Hours',
                type: 'column',
                data: office_HoursArr
              }
              tempSeries.push(tempSeriesBuilder)

              tempSeriesBuilder = {
                name: 'Truck Hours',
                type: 'column',
                data: truck_HoursArr
              }
              tempSeries.push(tempSeriesBuilder)            

              let totalBuildArr = []
              for (let i = 0; i < xaxis.length; i++) {
                let totalOfficeHr = (office_HoursArr[i] != null && office_HoursArr[i] != NaN) ? parseFloat(office_HoursArr[i]) : 0
                let totalTruckHr = (truck_HoursArr[i] != null && truck_HoursArr[i] != NaN) ? parseFloat(truck_HoursArr[i]) : 0
                let deviceTotal = parseFloat(totalOfficeHr + totalTruckHr).toFixed(2)

                totalBuildArr.push(parseFloat(deviceTotal))
              }             

              tempSeriesBuilder = {
                name: 'Total',
                type: 'line',
                data: totalBuildArr,
                color: '#6af2f0'
              }
              tempSeries.push(tempSeriesBuilder)              

              // Assign sorted data to graph
              this.$nextTick(() => {
                this.updateApexCharts(
                  this.hoursByOperatorsByTypeOptions.chart.id,
                  {
                    series: tempSeries,
                    xaxis: {
                      categories: xaxis
                    }
                  }
                )
              })

              this.$refs.hoursByOperatorsByTypeChart.updateOptions({
                chart: {
                  toolbar: {
                    export: {
                      csv: {
                        filename: this.getDownLoadFileName('HoursByOperator'),
                      },
                      svg: {
                        filename: this.getDownLoadFileName('HoursByOperator'),
                      },
                      png: {
                        filename: this.getDownLoadFileName('HoursByOperator'),
                      },
                    },
                  },
                },
              })
            }
            else {
              this.showOperatorHoursTabs = false
            }
          })
          .catch(function (error) {
            console.log(error)
          })
      } else {
        console.log('No User Token')
      }
    },
    async updateHoursTypeOperators(params) {
      if (sessionStorage.token) {
        await axios
          .get(process.env.API_LOCATION + '/api/dpr/reports/updateHoursTypeOperators', {
            headers: {
              'x-auth-token': sessionStorage.token
            },
            params: params
          })
          .then(response => {
            if (response.data.rows.length <= 0) {
              this.showOperatorHoursTabs = false
              return
            }

            let filResult = response.data.rows.filter(x => x.total_hours != null)

            // Sort response data into appropriate axis for graphing
            if (filResult.length > 0) {

              this.showOperatorHoursTabs = true
              let hoursType = []
              let hoursTypeSum = []
              let sum = 0 //added new variable for displaying sum
              response.data.rows.forEach(element => {
                if (element.total_hours) {
                  hoursType.push(element.hours_label)
                  hoursTypeSum.push(parseInt(element.total_hours))
                }

                sum += parseFloat(parseInt(element.total_hours)) // Sum of the total_days_down
              })
              // Assign sorted data to graph
              this.$nextTick(() => {
                this.updateApexCharts(
                  this.hoursTypeOperatorsOptions.chart.id,
                  {
                    series: hoursTypeSum,
                    labels: hoursType
                  }
                )

                this.$refs.totalOperatorsHoursTypeChart?.updateOptions({
                  chart: {
                    toolbar: {
                      export: {
                        csv: {
                          filename: this.getDownLoadFileName('TotalHoursType'),
                        },
                        svg: {
                          filename: this.getDownLoadFileName('TotalHoursType'),
                        },
                        png: {
                          filename: this.getDownLoadFileName('TotalHoursType'),
                        },
                      },
                    },
                  },
                })
              })
            }
            else {
              this.showOperatorHoursTabs = false
            }
          })
          .catch(function (error) {
            console.log(error)
          })
      } else {
        console.log('No User Token')
      }
    },    

/* -------------------------------End Hours By Operators ------------------------------------*/

    clickEventQuarterlyYear() {
      this.reportsSelectedQuarter = 1
      this.setAvailableQuarters()
      this.refreshAllGraphs()
    },
    getDownLoadFileName(fileType) {
      let downloadFilename = fileType + '_'
        + this.reportsFrequencySelected + '_'
        + 'Report' + '_'
        + this.getDateStringForFileName()
      return downloadFilename
    },
    getDateStringForFileName() {
      const now = new Date()
      const yyyy = now.getFullYear()
      const mm = String(now.getMonth() + 1).padStart(2, '0')
      const dd = String(now.getDate()).padStart(2, '0')
      const hh = String(now.getHours()).padStart(2, '0')
      const min = String(now.getMinutes()).padStart(2, '0')
      return `${yyyy}-${mm}-${dd}_${hh}:${min}`
    }
  }
}
</script>
